import { Component, Input } from '@angular/core';
import {
  InlineToast,
  InlineToastService,
  InlineToastTypes,
} from '@shared/services/inline-toast/inline-toast.service';

@Component({
  selector: 'app-inline-toast',
  templateUrl: './inline-toast.component.html',
  styleUrls: ['./inline-toast.component.scss'],
})
export class InlineToastComponent {
  @Input() toast: InlineToast;
  @Input() canDismiss = true;
  types = InlineToastTypes;

  constructor(private inlineToastService: InlineToastService) {}

  dismiss() {
    this.inlineToastService.clearToast();
  }
}
